
import React, { useEffect, useState } from 'react';
import { Table,Card,Spin,Menu,Modal,Form,Input,Tag} from 'antd';
import { EditOutlined, DownloadOutlined } from '@ant-design/icons';
import utils from 'cl-library/dist/utils/index'
// import MoreTableData from './moreTableData';
import { CSVLink } from "react-csv";
import EllipsisDropdown from 'cl-library/dist/components/shared-components/EllipsisDropdown/index';
import Flex from 'cl-library/dist/components/shared-components/Flex/index'
import config from "../../config.json";
import RmName from "../../RmName.json";
// import EditStudentDetail from './editDetails'
// import LabelStudent from './labelChangeDetails'
import axios from 'axios';
const header=[
{label:"Date",key:"Date"},
{label:(RmName.name),key:"rm_code"},
{label:"Token_no",key:"token_no"},
{label:"Label_status",key:"label_status"},
{label:"Label_problem",key:"label_problem"},
];

const token = localStorage.getItem("token");
const TableData = ({data}) =>{
let date= new Date();
const today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
const time=`${date.getHours()}:${date.getMinutes()}`

  let csvRport={
    filename:`"English sheet"+${today}+${time}`,
    headers:header,
    data:data
}
const [apiError, setapiError] = useState(null);

    const [loading, setLoading] = useState(true);  
    // // eslint-disable-next-line
    const [tableData,setTableData]=useState(data);
    // eslint-disable-next-line
    const [edit,setEdit]=useState(false);
    const [labelEdit,setLabelEdit]=useState(false);
    const [editLabelDetail,setEditLabelDetail] = useState({});
    const [editDetail,setEditDetail] = useState({});


    const columns = [
          {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Date')
          },
          {
            title:(RmName.name),
            dataIndex: "RM_code",
            key: "RM_code",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'rm_code')
          },
          {
            title: "Token No",
            dataIndex: "Token_no",
            key: "Token_no",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'token_no')
          },
          {
            title: "Label status",
            dataIndex: "Label_status",
            key: "Label_status",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'label_status')
          },
          {
            title: "Label problem",
            dataIndex: "Label_problem",
            key: "Label_problem",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'label_problem')
          },
    ];


    useEffect(()=>{
      async function fatchData(){
        data.map((obj,index)=>{obj.index=index})
        setTableData(data);
        setLoading(false)
      }
      fatchData();
      // eslint-disable-next-line 
    },[data])

    const dropdownMenu = elm => (
      <Menu>
        {elm.status==="Pending" != elm.status==="Done" || elm.status==="Done"?
        <Menu.Item disabled={true}>
          <Flex alignItems="center">     
            <span className="ml-2" onClick={() => showModal(elm)}><EditOutlined className='mr-1'/>Label Change Form</span>
          </Flex>
        </Menu.Item>
         : 
         <Menu.Item  >
          <Flex alignItems="center">     
            <span className="ml-2" onClick={() => showModal(elm)}><EditOutlined className='mr-1'/>Label Change Form</span>
          </Flex>
        </Menu.Item>}
        { elm.status==="Duplicate" || elm.status==="Done" ?
         <Menu.Item disabled={true}>
         <Flex alignItems="center">     
           <span className="ml-2" onClick={() => EditStudent(elm)}><EditOutlined className='mr-1'/>Duplicate</span>
         </Flex>
       </Menu.Item>
       :
       <Menu.Item>
       <Flex alignItems="center">     
         <span className="ml-2" onClick={() => EditStudent(elm)}><EditOutlined className='mr-1'/>Duplicate</span>
       </Flex>
     </Menu.Item>
        }
      </Menu>
    );

    const getStatus = record => {
      if(record.status ==='Done') {
        return 'success'
      }
      if(record.status === 'Pending') {
        return 'warning'
      }
      if(record.status === 'Duplicate') {
        return 'error'

      }
      return ''
    }
  //   let initialFormValues = {
  //     token: data.token_no,

  // }


    useEffect(()=>{

      async function fatchData(){
        data.map((obj,index)=>{obj.index=index})
        setTableData(data);
        setLoading(false)
      }
      fatchData();
      // eslint-disable-next-line 
    },[data])

    const EditStudent=(elm)=>{
      setEditDetail(elm);
      setEdit(true);
    }

    const showModal = (elm) => {
      setEditLabelDetail(elm);
      setLabelEdit(true);
    }

    return (
      loading ? (<Spin tip='loading'></Spin>) :
        <>      
            <Card title="Math label history" 
                  style={{ 'fontSize': '5px' }} 
                  extra={ 
                        <CSVLink {...csvRport}>
                         <DownloadOutlined style={{ 'fontSize': 30 }}/>
                        </CSVLink>
                      }> 
                  <Table xs={24} sm={50} md={50}
                      columns={columns} 
                      dataSource={tableData} 
                      rowKey='index'  
                      // expandable={{ expandedRowRender:record=>{
                      //   return <MoreTableData record={record}/>;
                      // } }} 
                    />

              </Card>

              {/* {labelEdit? 
              <LabelStudent 
                onCancel = {()=>setLabelEdit(false)}
                item = {editLabelDetail}
                labelEdit={labelEdit}
                />
            :
            ""
            }
              {edit?
            <EditStudentDetail
                onCancel={()=>setEdit(false)}
                item={editDetail}
                showEdit={edit}/>
            :""} */}

        </>
    )
}

export default TableData